export const SUBMIT_KITCHEN_ITEM = "SUBMIT_KITCHEN_ITEM";
export const SUBMIT_KITCHEN_ITEM_SUCCESS = "SUBMIT_KITCHEN_ITEM_SUCCESS";
export const SUBMIT_KITCHEN_ITEM_ERROR = "SUBMIT_KITCHEN_ITEM_ERROR";